import { Button, DatePicker, Form, Grid, Input, Select } from 'antd';
import { ContentFilters } from 'components';
import { StandardItemsWrapper } from 'components/content-filters/content-filters.styles';
import {
  assignFormFilterFeild,
  assignFormFilterValue,
} from 'features/assigned-clients/components/form-filter/type';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DATE_FORMATS } from 'utils/date';
const { RangePicker } = DatePicker;

const { useBreakpoint } = Grid;
type AssignFilterFormProps = {
  formId: string;
  handleFilter: (values: assignFormFilterValue) => void;
  initialValues: assignFormFilterValue;
  closeModal?: () => void;
};
export const AssignilterForm = ({
  formId,
  handleFilter,
  initialValues,
  closeModal,
}: AssignFilterFormProps) => {
  const [validateTrigger, setValidateTrigger] = useState(['onSubmit']);
  const [form] = Form.useForm<assignFormFilterValue>();
  const { t } = useTranslation();
  const screens = useBreakpoint();
  const onReset = () => {
    form.resetFields();
    handleFilter({ ...initialValues });
  };
  const onFinish = (formValues: assignFormFilterValue) => {
    handleFilter(formValues);
    closeModal?.();
  };

  return (
    <Form<assignFormFilterValue>
      id={formId}
      name={formId}
      className='filters-form'
      form={form}
      layout='vertical'
      onFinish={onFinish}
      initialValues={initialValues}
      onFinishFailed={() => {
        setValidateTrigger(['onChange']);
      }}
      validateTrigger={validateTrigger}
    >
      <ContentFilters.FormItemsWrapper>
        <StandardItemsWrapper className='form_fltrbx'>
          <Form.Item<assignFormFilterFeild>
            label={'Client Name'}
            name={assignFormFilterFeild.Name}
          >
            <Input placeholder={'Enter Client Name'} />
          </Form.Item>
          <Form.Item<assignFormFilterFeild>
            label={'Email'}
            name={assignFormFilterFeild.Email}
          >
            <Input placeholder={'Enter Email'} />
          </Form.Item>
          <Form.Item<assignFormFilterFeild>
            label={'Business Name'}
            name={'BussinessName'}
          >
            <Input placeholder={'Enter Business Name'} />
          </Form.Item>
          <Form.Item<assignFormFilterFeild>
            label={'Assigned Admin'}
            name={'AssignClientName'}
          >
            <Input placeholder={'Enter Assigned Admin'} />
          </Form.Item>
          <Form.Item<assignFormFilterFeild>
            label={'Last Update'}
            name={assignFormFilterFeild.Date}
          >
            <RangePicker format={DATE_FORMATS.date} />
          </Form.Item>
          <Form.Item<assignFormFilterFeild> label={'Status'} name={`StatusId`}>
            <Select
              defaultValue={'Active'}
              options={[
                { value: 'true', label: 'Active' },
                { value: 'false', label: 'InActive' },
              ]}
              placeholder={'Select Status'}
            />
          </Form.Item>
        </StandardItemsWrapper>
      </ContentFilters.FormItemsWrapper>
      {/* ghg */}
      {screens.lg && (
        <ContentFilters.ButtonsWrapper>
          <Button type='primary' htmlType='submit'>
            {t('common.buttons.filter', { count: 1 })}
          </Button>
          <Button onClick={onReset}>{t('common.buttons.reset')}</Button>
        </ContentFilters.ButtonsWrapper>
      )}
    </Form>
  );
};
